import React from 'react'
import parse from 'html-react-parser'
import { splitFill } from '../../utils'

export function Parameter({ parameters, id }) {
  return (
    <>
      <h3 id={id}>Parameter</h3>
      <table>
        <thead>
          <tr>
            <th>Field</th>
            <th>Type</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          {parameters.map(parameter => (
            <tr key={parameter.field}>
              <td>
                {parse(splitFill(parameter.field))}
                {parameter.optional && <sub className='label-optional'>optional</sub>}
              </td>
              <td>{parameter.type}</td>
              <td>
                {parse(parameter.description)}
                {parameter.defaultValue && (
                  <p>
                    Default value: <code>{parameter.defaultValue}</code>
                  </p>
                )}
                {parameter.allowedValues && (
                  <p>
                    Allowed values:{' '}
                    {parameter.allowedValues.map((v, i, arr) => (
                      <React.Fragment key={v}>
                        <code>{v}</code>
                        {arr.length - 1 !== i && ','}
                      </React.Fragment>
                    ))}
                  </p>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  )
}
